import React, {Fragment, useEffect, useRef, useState} from "react";
import {Badge, Card, CardBody, Col, FormGroup, Input, Label, Media, Alert,  Modal,  ModalHeader,  ModalBody,  ModalFooter,  Spinner} from "reactstrap";
import ImageUploader from 'react-images-upload';
import {openNewDialog} from "../../../../manage-user/store/userSlice";
import {Button, Row} from "react-bootstrap";
import DropZone from "../../../../../share-components/upload/dropzone";
import {useDispatch} from "react-redux";
import dragula from 'react-dragula';
import {
    addProductImage,
    deleteProductImage,
    sortProductImage,
    updateProductImageAlt,
    generateAiProductImages,
    retouchAiProductImages,
} from "../../../store/prodcutSlice";
import {get} from "react-hook-form";
import {getFileExtension} from "../../../../../utils/common";


import ReactImageVideoLightbox from "react-image-video-lightbox";
import Select from "react-select";
import {toast} from "react-toastify";
import { MdAutoAwesome } from "react-icons/md";

const ProductImage = (props) => {
    const {productState, setValue, trigger, getValues,onConfirmSendImage,currentUser} = props;
    const dispatch = useDispatch();
    let imageAltRef = useRef([]);
    
    const [imagePreloader, setImageLoader] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);

    const [viewFile, setViewFile] = useState([]);
    const [dragulaKey, setDragulaKey] = useState(0);

    const dragulaRef = useRef(null);
    const dragulaInstance = useRef(null);

    const [aiMode, setAiMode] = useState(null); // "generate" | "retouch" | null
    const [aiPrompt, setAiPrompt] = useState("");
    const [aiAspectRatio, setAiAspectRatio] = useState("1:1");
    const [aiProcessing, setAiProcessing] = useState(false);
    const [aiNumImages, setAiNumImages] = useState(5); // default 5 (max 10)

    useEffect(() => {
        if (dragulaRef.current && !dragulaInstance.current) {
            dragulaInstance.current = dragula([dragulaRef.current], {
                moves: (el, source, handle) => true,
                accepts: (el, target, source, sibling) => true,
                invalid: (el, handle) => false,
            });

            dragulaInstance.current.on("drop", (el, target, source, sibling) => {
                const cardOrder = [...target.children];
                const imageIds = cardOrder.map(item => item.getAttribute("data-id")).filter(Boolean);

                dispatch(sortProductImage({ id: getValues("id"), image_ids: imageIds }));
            });
        }

        return () => {
            if (dragulaInstance.current) {
                dragulaInstance.current.destroy();
                dragulaInstance.current = null;
            }
        };
    }, [getValues('images'), dispatch]);

    const validateImage = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const megapixels = (width * height) / 1_000_000; // Convert to MP
                
                if (megapixels > 25) {
                    reject("Image size should not exceed 25 megapixels.");
                } else {
                    resolve("Valid Image");
                }
            };
            img.onerror = () => reject("Invalid image file.");
        });
    };

    const onChangeFile = async (e, error) => {
        if(error.length>0){
            toast.error("one or many of the uploaded file size more than 20MB for image and 100MB for video", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }else {
            if (e.length > 0) {
                let fileSizeError = false;
                let validationErrors = [];
        
                for (const file of e) {
                    if (/^image\//.test(file.type) && file.size > 20971520) {
                        fileSizeError = true;
                    } else if (file.type === 'video/mp4' && file.size > 104857600) {
                        fileSizeError = true;
                    }
        
                    if (/^image\//.test(file.type)) {
                        try {
                            await validateImage(file);
                        } catch (error) {
                            validationErrors.push(error);
                        }
                    }
                }

                if (fileSizeError || validationErrors.length > 0) {
                    toast.error(
                        fileSizeError 
                            ? "One or more files exceed size limits (20MB for images, 100MB for videos)." 
                            : validationErrors.join(", "),
                        { position: toast.POSITION.TOP_RIGHT }
                    );
                    return;
                }

                setImageLoader(true);
                dispatch(addProductImage({
                    id: getValues('id'),
                    image: e,
                    shopify_product_id: getValues('shopify_product_id')
                })).then(res => {
                    if (!res.error) {
                        setValue('images', res.payload);
                        trigger('images');
                        setDragulaKey(dragulaKey + 1);
                        setImageLoader(false);
                    }
                    ;
                });
            }
        }
    };

    const deleteImage = (item) => {
        dispatch(deleteProductImage(item.id)).then(res => {
            if (!res.error) {
                setValue('images', res.payload);
                trigger('images');
                setDragulaKey(dragulaKey + 1);
            }
        });
    }

    const initilindex = {index: 0, isOpen: false}
    const [photoIndex, setPhotoIndex] = useState(initilindex)
    const [selectedColour,setSelectedColour]=useState(0);

    // const onMovePrev = () => {
    //     const prev = (photoIndex.index + getValues('images').length - 1) % getValues('images').length
    //     setPhotoIndex({...photoIndex, index: prev})
    //     imageAltRef.current[photoIndex.index].value = getValues('images')[prev].image_alt;
    // }
    const onMoveNext = (index) => {
        imageAltRef.current.value = getValues('images')[index].image_alt;
        setSelectedColour(getValues('images')[index].colour_id);
    }
    const updateImageAltText = (index) => {
        let imageText = imageAltRef.current;
        getValues('images')[photoIndex.index].image_alt = imageText.value;
        setIsUpdated(true);

    }
    const setImageColour=(index,item)=>{
        getValues('images')[photoIndex.index].colour_id = item.id;
        getValues('images')[photoIndex.index].colour = item;
        setSelectedColour(item.id);
        setIsUpdated(true);
    }
    const updateAltTagWithColour=()=>{
        if(isUpdated) {
            const images = getValues('images').map(elem => (
                {
                    id: elem.id,
                    colour_id: elem.colour_id,
                    image_alt:elem.image_alt
                }
            ));
            dispatch(updateProductImageAlt({images:images})).then(res => {
                if (!res.error) {
                   setIsUpdated(false);
                }
            });
        }

    }
    useEffect(()=>{
        if(photoIndex.isOpen) {
            setSelectedColour(getValues('images')[photoIndex.index].colour_id);
            imageAltRef.current.value = getValues('images')[photoIndex.index].image_alt;
        }
    },[photoIndex.index,photoIndex.isOpen])
    useEffect(() => {
        let dataImage = [];
        getValues('images').map((item, i) => {
            dataImage.push({
                url: item.image_path,
                type: getFileExtension(item.image_path) == ".mp4" ? "video" : "photo",
                altTag: "some image",
            });
        });
        setViewFile(dataImage);
    }, [getValues('images')]);

    //const hasImagesOnly = (media = []) => media.some(item => item.media_type !== "video");
    const hasImagesOnly = (media = []) => (media || []).some(item => getFileExtension(item.image_path) !== ".mp4");

    return (
        <Fragment>
            {aiProcessing && (
                <div
                    style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 2000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: 12,
                    }}
                >
                    <Spinner />
                    <div style={{ fontWeight: 500 }}>
                    {aiMode === "generate" ? "Generating images…" : "Retouching images…"}
                    </div>
                </div>
            )}
            <Card>
                <CardBody>
                    <div className="ribbon ribbon-clip ribbon-primary ribbon-left mb-5">Images</div>

                    <div className="d-flex justify-content-end mb-2">
                        <div className="d-flex align-items-center gap-2">
                            {/* Generate Images – always visible */}
                            <Button
                            type="button"
                            color="primary"
                            size="sm"
                            onClick={() => setAiMode("generate")}
                            className="d-flex align-items-center gap-1"
                            >
                            <MdAutoAwesome style={{ fontSize: 16 }} /> &nbsp;&nbsp;
                            Generate Images
                            </Button>

                            {/* Retouch Images – only if images exist */}
                            {hasImagesOnly(getValues("images")) && (
                            <Button
                                type="button"
                                color="secondary"
                                size="sm"
                                onClick={() => setAiMode("retouch")}
                                className="d-flex align-items-center gap-1 ml-3"
                            >
                                <MdAutoAwesome style={{ fontSize: 16 }} /> &nbsp;&nbsp;
                                Retouch Images
                            </Button>
                            )}
                        </div>
                    </div>

                    <div className="form-row mb-3 mt-3">
                        <div className="col-4 offset-8">
                            <Alert color="primary outline">
                                <span>{"Videos can be uploaded after publish"}</span>
                            </Alert>
                        </div>
                    </div>
                    <div className="form-row mb-3">

                        <div ref={dragulaRef} style={{display: "contents"}} key={dragulaKey}>
                            {getValues('images').map((item, i) => <Col md={2} index={i} data-id={item.id} key={i}>


                                <Card>
                                    <div className="product-box">
                                        <div className="product-img">
                                            <div><Badge key={i} onClick={()=>{
                                                setImageColour(photoIndex.index,item);
                                            }}  className={`image-color badge bg-light text-dark`}>{item.colour?item.colour.name:"None"}</Badge></div>
                                            <div className="image-crop-center" style={{height: 200}}>
                                                {getFileExtension(item.image_path) == ".mp4" ?
                                                    <video height="200" width={350} autoPlay={true} muted={true}
                                                           loop={true}>
                                                        <source src={item.image_path} type="video/mp4"/>
                                                    </video>
                                                    : <img className="img-fluid scale-image-6" src={item.image_path}
                                                           alt=""/>}
                                            </div>
                                            <div className="product-hover">
                                                <ul>
                                                    <li>
                                                        <Button color="default" onClick={() => {
                                                            setPhotoIndex({...photoIndex, index: i, isOpen: true})
                                                        }}>
                                                            <i className="icon-eye"></i>
                                                        </Button>
                                                    </li>
                                                    <li>
                                                        <Button color="red" onClick={() => {
                                                            deleteImage(item)
                                                        }}>
                                                            <i className="icon-trash"></i>
                                                        </Button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/*<div className="product-details text-center">*/}
                                        {/*    <h6 className="font-primary" >test</h6>*/}
                                        {/*</div>*/}
                                    </div>
                                </Card>


                            </Col>)}
                        </div>
                        <Col md={2}>
                            <Card>
                                <div className="product-box">
                                    <div className="product-img pt-3 pb-3">
                                        {imagePreloader && <div className="loader-box">
                                            <div className="loader-2"></div>
                                        </div>}
                                        {!imagePreloader && <DropZone multiple
                                            // acceptFiles={getValues('shopify_product_id')?"image/*,.mp4":"image/*"}
                                            extension={getValues('shopify_product_id') ? "image/*,.mp4" : "image/*"}
                                            onChangeFile={onChangeFile}></DropZone>}
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </div>
                    {(currentUser.modules).includes('send-image') &&   <div className="form-row">
                        <div className="col-4 offset-8">
                            <Button onClick={onConfirmSendImage} className="pull-right  font-weight-bold mr-2" color="success"
                                    type="button">Send Image
                            </Button>
                        </div>
                    </div>}
                </CardBody>
            </Card>
            {photoIndex.isOpen && (
                <div style={{height: '100vh'}}>
                    <div className="lightbox-div">
                        <ReactImageVideoLightbox
                            title={"DAd"}
                            data={viewFile}
                            startIndex={photoIndex.index}
                            showResourceCount={true}
                            onCloseCallback={() => {
                                updateAltTagWithColour();
                                setPhotoIndex({...photoIndex, isOpen: false})
                            }}
                            onNavigationCallback={(currentIndex) =>{

                                setPhotoIndex({...photoIndex, index: currentIndex})
                                onMoveNext(currentIndex);
                            }}
                        >

                        </ReactImageVideoLightbox>
                        <div className="p-5" style={{zIndex: 300, bottom: 0, position: "fixed", right: 0}}>
                            <div>
                                <input name="altText" type="text"
                                       placeholder="Alt Text"
                                       ref={(ref)=>{
                                           imageAltRef.current=ref;
                                       }}
                                       onBlur={(e) => {
                                           updateImageAltText(photoIndex.index);
                                       }}
                                       className={`form-control`}/>
                            </div>
                            <div className="pt-2">
                                    {getValues('color').map((item, i) => <Badge key={i} onClick={()=>{
                                        setImageColour(photoIndex.index,item);
                                    }}  className={`image-color badge bg-light text-dark ${selectedColour == item.id?`active-image-color`:""}`}>{item.name}</Badge>)}

                            </div>
                        </div>
                    </div>

                </div>
            )}
            <Modal isOpen={!!aiMode} toggle={() => setAiMode(null)} centered size="lg">
                <ModalHeader toggle={() => setAiMode(null)}>
                    <div>
                        <div style={{ fontWeight: 600 }}>
                        {aiMode === "generate"
                            ? "Generate Images with AI"
                            : "Retouch Images with AI"}
                        </div>

                        <div style={{ fontSize: 13, color: "#6c757d", marginTop: 4 }}>
                        {aiMode === "generate"
                            ? "Create new product visuals, variations, or scenes from scratch using AI."
                            : "Enhance clarity, improve lighting, sharpen details, and clean up visuals of existing images."}
                        </div>
                    </div>
                </ModalHeader>

                <ModalBody>
                    <FormGroup>
                    <Label>Prompt</Label>
                    <Input
                        type="textarea"
                        rows={4}
                        placeholder="Describe what you want the final images to look like…"
                        value={aiPrompt}
                        onChange={(e) => setAiPrompt(e.target.value)}
                    />
                    </FormGroup>

                    {aiMode === "generate" && (
                        <FormGroup className="mt-3">
                            <Label>Number of Images</Label>
                            <Input
                            type="select"
                            value={aiNumImages}
                            onChange={(e) => setAiNumImages(parseInt(e.target.value, 10))}
                            >
                            {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
                                <option key={n} value={n}>
                                {n}
                                </option>
                            ))}
                            </Input>
                            <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                            Max 10. Default 5.
                            </div>
                        </FormGroup>
                    )}

                    <FormGroup className="mt-3">
                    <Label>Aspect Ratio</Label>
                    <Input
                        type="select"
                        value={aiAspectRatio}
                        onChange={(e) => setAiAspectRatio(e.target.value)}
                    >
                        <option value="1:1">Square (1:1)</option>
                        <option value="4:5">Portrait (4:5)</option>
                        <option value="3:4">Portrait (3:4)</option>
                        <option value="16:9">Landscape (16:9)</option>
                    </Input>
                    </FormGroup>
                </ModalBody>

                <ModalFooter>
                    <Button
                    color="secondary"
                    onClick={() => setAiMode(null)}
                    disabled={aiProcessing}
                    >
                    Cancel
                    </Button>

                    <Button
                    color="primary"
                    onClick={() => {
                        setAiProcessing(true);

                        const productId = getValues("id");

                        const action =
                            aiMode === "generate"
                                ? generateAiProductImages({
                                    productId,
                                    prompt: aiPrompt,
                                    aspect_ratio: aiAspectRatio,
                                    num_images: aiNumImages,
                                })
                                : retouchAiProductImages({
                                    productId,
                                    prompt: aiPrompt,
                                    aspect_ratio: aiAspectRatio,
                                });

                        dispatch(action)
                            .then((res) => {
                                if (!res.error) {
                                    // backend returns same format as uploadImage() => array of images
                                    setValue("images", res.payload);
                                    trigger("images");
                                    setDragulaKey(dragulaKey + 1);

                                    // reset UI
                                    setAiPrompt("");
                                    setAiAspectRatio("1:1");
                                    setAiNumImages(5);
                                    setAiMode(null);
                                }
                            })
                            .finally(() => {
                                setAiProcessing(false);
                            });
                    }}
                    disabled={!aiPrompt || aiProcessing}
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                    {aiProcessing ? <Spinner size="sm" /> : <MdAutoAwesome />}
                    Continue
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    )
};

export default ProductImage;

